import React from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
  TextField,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  AddCircle,
  ExitToApp,
  ShareOutlined,
  Storefront,
  Twitter,
  Upload,
  WarehouseOutlined,
  Print,
} from "@mui/icons-material";
import {
  bulk_order_admin,
  get_sales_order,
  get_sales_rep,
  get_status,
  print_summary,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-simple-toasts";

export default function Sale() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);
  const [statusKey, setStatusKey] = React.useState("all");
  const [salerepData, setSalerepData] = React.useState(null);
  const [statusData, setStatusData] = React.useState(null);
  const [salerep, setSalerep] = React.useState(0);
  const [allData, setAllData] = React.useState([]);
  const [country, setCountry] = React.useState(0);

  const handleCHangeStatus = (event) => {
    setStatusKey(event.target.value);
    window.localStorage.setItem("status", event.target.value);
  };

  const handleChangeRep = (event) => {
    setSalerep(event.target.value);
    window.localStorage.setItem("salerep", event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");
  const [debouncedSearchKey, setDebouncedSearchKey] = React.useState("");
  const searchTimeoutRef = React.useRef(null);

  const searchData = (data, searchKey) => {
    var _data = [];
    if (searchKey != "") {
      for (var i = 0; i < data.length; i++) {
        if (
          data[i].sales_order_id.indexOf(searchKey) > -1 ||
          (data[i].entityid &&
            data[i].entityid.toUpperCase().indexOf(searchKey.toUpperCase()) >
              -1)
        ) {
          _data.push(data[i]);
        }
      }
    } else {
      _data = [...data];
    }

    return _data;
  };

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchKey(value);
    setPageNum(0);
    
    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    
    // Set new timeout to update debouncedSearchKey after user stops typing (500ms)
    searchTimeoutRef.current = setTimeout(() => {
      setDebouncedSearchKey(value);
    }, 500);
  };

  const handlePrint = () => {
    print_summary({
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: statusKey,
      salesrep: salerep,
    }).then((res) => {
      window.open(res.data);
      // setSelectedRep(resRep.data[0].internalid)
    });
  };

  // const [dateFrom, setDateFrom] = React.useState(moment().subtract(30, 'days').format("YYYY-MM-DD"));

  // const handleChangeDateFrom = (event) => {
  //     setDateFrom(event.target.value);

  //     window.localStorage.setItem("datefrom", event.target.value)

  // };

  const [dateFrom, setDateFrom] = React.useState(() => {
    const storedDateFrom = window.localStorage.getItem("datefrom");
    if (storedDateFrom) {
      return storedDateFrom;
    } else {
      return moment().subtract(25, "days").format("YYYY-MM-DD");
    }
  });

  // const handleChangeDateFrom = (event) => {
  //   const value = event.target.value;
  //   const maxAllowedDateTo = moment(value).add(30, "days").format("YYYY-MM-DD");

  //   if (moment(dateTo).isAfter(maxAllowedDateTo)) {
  //     setDateTo(maxAllowedDateTo);
  //     window.localStorage.setItem("dateto", maxAllowedDateTo);
  //   }

  //   setDateFrom(value);
  //   window.localStorage.setItem("datefrom", value);
  // };

  const handleChangeDateFrom = (event) => {
    const value = event.target.value;
    
    if (!value || value === "") {
      toast("Date From cannot be empty");
      return;
    }

    const maxAllowedDateTo = moment(value).add(25, "days").format("YYYY-MM-DD");

    if (moment(dateTo).isAfter(maxAllowedDateTo)) {
      alert("Date range cannot exceed 25 days.");
      setDateTo(maxAllowedDateTo);
      window.localStorage.setItem("dateto", maxAllowedDateTo);
    }

    setDateFrom(value);
    window.localStorage.setItem("datefrom", value);
  };

  const [dateTo, setDateTo] = React.useState(() => {
    const storedDateTo = window.localStorage.getItem("dateto");
    if (storedDateTo) {
      return storedDateTo;
    } else {
      return moment().format("YYYY-MM-DD");
    }
  });

  // const handleChangeDateTo = (event) => {
  //   const value = event.target.value;
  //   const minAllowedDateFrom = moment(value).subtract(30, "days").format("YYYY-MM-DD");

  //   if (moment(dateFrom).isBefore(minAllowedDateFrom)) {
  //     setDateFrom(minAllowedDateFrom);
  //     window.localStorage.setItem("datefrom", minAllowedDateFrom);
  //   }

  //   setDateTo(value);
  //   window.localStorage.setItem("dateto", value);
  // };

  const handleChangeDateTo = (event) => {
    const value = event.target.value;
    
    if (!value || value === "") {
      toast("Date To cannot be empty");
      return;
    }

    const minAllowedDateFrom = moment(value)
      .subtract(25, "days")
      .format("YYYY-MM-DD");

    if (moment(dateFrom).isBefore(minAllowedDateFrom)) {
      alert("Date range cannot exceed 25 days.");
      setDateFrom(minAllowedDateFrom);
      window.localStorage.setItem("datefrom", minAllowedDateFrom);
    }

    setDateTo(value);
    window.localStorage.setItem("dateto", value);
  };

  const handleChangeCountry = (e) => {
    setCountry(e.target.value);
    window.localStorage.setItem("country", e.target.value);
  };

  const [loading, setLoading] = React.useState(false);
  const [totalList, setTotalList] = React.useState(1);
  const [pageNum, setPageNum] = React.useState(0);

  // const [receive, setReceive] = React.useState(
  //   JSON.parse(window.localStorage.getItem("filterDataSales"))
  // );

  const [receive, setReceive] = React.useState(null);

  const getRep = () => {
    get_sales_rep({}).then((resRep) => {
      setSalerepData(resRep.data);
      // setSelectedRep(resRep.data[0].internalid)
    });

    get_status({}).then((resStatus) => {
      setStatusData(resStatus.data);
      // setSelectedRep(resRep.data[0].internalid)
    });
  };

  const getData = async () => {
    setLoading(true);
    try {
      const json = await get_sales_order({
        page: pageNum,
        dateFrom: dateFrom,
        dateTo: dateTo,
        status: statusKey,
        salesrep: salerep,
        country: country,
        search: debouncedSearchKey,
        // sort: sort
      });
      setLoading(false);
      setAllData(json.data);
      setReceive(json.data);

      setTotalList(json.total);
    } catch (error) {
      // Handle error if needed
      setLoading(false);
      console.error(error);
    }
  };

  // console.log(totalList)

  const getDataDate = async () => {
    try {
      // Validate date filters
      if (!dateFrom || dateFrom === "" || !dateTo || dateTo === "") {
        toast("Date From and Date To cannot be empty");
        setLoading(false);
        return;
      }

      setLoading(true);
      // setPageNum(0);
      const json = await get_sales_order({
        page: pageNum,
        dateFrom: dateFrom,
        dateTo: dateTo,
        status: statusKey,
        salesrep: salerep,
        country: country,
        search: debouncedSearchKey,
        // sort: sort
      });
      setLoading(false);
      setAllData(json.data);
      // setReceive(
      //   localStorage.setItem("filterDataSales", JSON.stringify(_data))
      // );
      setReceive(json.data);
      const storedDateFrom = window.localStorage.getItem("datefrom");
      if (storedDateFrom) {
        setDateFrom(storedDateFrom);
      }
      const storedDateTo = window.localStorage.getItem("dateto");
      if (storedDateTo) {
        setDateTo(storedDateTo);
      }

      const storedStatusKey = window.localStorage.getItem("status");
      if (storedStatusKey) {
        setStatusKey(storedStatusKey);
      }

      const storedSalerep = window.localStorage.getItem("salerep");
      if (storedSalerep) {
        setSalerep(storedSalerep);
      }

      const storedPageNum = window.localStorage.getItem("pagenum");
      if (storedPageNum) {
        setPageNum(storedPageNum);
      }

      const storedCountry = window.localStorage.getItem("country");
      if (storedCountry) {
        setCountry(storedCountry);
      }

      // localStorage.setItem("filterDataSales", JSON.stringify(_data));

      //  setReceive(JSON.parse(a));
      setTotalList(json.total);

      console.log(json.data);
    } catch (error) {
      // Handle error if needed
      setLoading(false);
      console.error(error);
    }
  };

  React.useEffect(() => {
    // getData();
  }, []);

  React.useEffect(() => {
    getRep();
  }, []);

  React.useEffect(() => {
    getDataDate();
  }, [dateFrom, dateTo, statusKey, salerep, pageNum, country, debouncedSearchKey]);
  
  // Cleanup timeout on unmount
  React.useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  // React.useEffect(() => {
  //   setReceive(JSON.parse(window.localStorage.getItem("filterDataSales")));
  // }, [JSON.parse(window.localStorage.getItem("filterDataSales"))]);

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
  };

  const handleBulkUpload = async (e, index) => {
    var formData = new FormData();

    formData.append("file", e.target.files[0]);
    // for (var i = 0; i < e.target.files.length; i++) {
    //     console.log(e.target.files[i])
    //     formData.append("images_" + i, e.target.files[i]);
    // }
    setLoading(true);
    bulk_order_admin(formData).then((res) => {
      console.log(res);
      // setisLoadingModal(false)
      // console.log('res', res);
      if (res.data.status) {
        // var img = [...images];
        // for (var i = 0; i < res.data.length; i++) {
        //     console.log("OK " + i);
        //     img.push(res.data[i]);
        // }
        // setImages(img);
        getData();
        toast("Order Uploaded");
      } else {
        toast(res.data.message);
        setLoading(false);
      }
    });
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <Navbar2
          children={
            <Section pd="2rem">
              <div>
                <div className={classes.theFlexHeader}>
                  {/* <div className={classes.theHeaderSelect}>
                                        <FormInput
                                            // label="Username"
                                            textLabelColor="#000"
                                            // placeholder="Username"
                                            // name="username"
                                            bold="600"
                                            border="0"
                                            size="24px"
                                            value={location.pathname.replace(/[^A-Za-z]+/g, "")}
                                            select
                                            onChange={handleHeader}
                                        >
                                            <MenuItem value="sale">Sale Order</MenuItem>
                                            <MenuItem value="invoice">Invoice</MenuItem>
                                        </FormInput>
                                    </div> */}
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Sale Order
                  </Paragraph>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: "0" }}
                  >
                    <a
                      className={classes.theCustomActionBtn_}
                      // style={{ position: "relative" }}
                      // className={classes.theCustomActionBtn}
                      onClick={() => handlePrint()}
                    >
                      <Print sx={{ color: "#1A5386" }} />
                      <Paragraph margin="0 0 0 .4rem">Print Order</Paragraph>
                    </a>
                    <a
                      className={classes.theCustomActionBtn_}
                      style={{ position: "relative" }}
                      // className={classes.theCustomActionBtn}
                      // onClick={() => navigate("/createorder")}
                    >
                      <Upload sx={{ color: "#1A5386" }} />
                      <Paragraph margin="0 0 0 .4rem">Import Order</Paragraph>
                      <input
                        className="ori-fileinput"
                        type="file"
                        name="file"
                        accept=".csv"
                        style={{
                          opacity: 0,
                          top: "0",
                          right: "0",
                          position: "absolute",
                          width: "100%",
                        }}
                        onChange={handleBulkUpload}
                      />
                    </a>
                    <a
                      className={classes.theCustomActionBtn_}
                      // className={classes.theCustomActionBtn}
                      onClick={() => navigate("/createorder")}
                    >
                      <AddCircle sx={{ color: "#1A5386" }} />
                      <Paragraph margin="0 0 0 .4rem">
                        Create New Order
                      </Paragraph>
                    </a>
                    {/* <a
                                            className={classes.theCustomActionBtn_}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <ExitToApp sx={{ color: "#1A5386" }} />
                                            <Paragraph margin="0 0 0 .4rem">Export</Paragraph>
                                        </a> */}
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: "2px solid #707070",
                    padding: ".2rem 0",
                  }}
                />
                <br />

                <div className={classes.theFlexAction}>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleSearch}
                      value={searchKey}
                    />
                  </div>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleCHangeStatus}
                      value={statusKey}
                      select
                    >
                      <MenuItem value="all">Select a Status</MenuItem>
                      {statusData != null &&
                        statusData.map((res) => (
                          <MenuItem
                            value={res.status_id}
                            style={{ color: "#000" }}
                          >
                            {res.name}
                          </MenuItem>
                        ))}
                      {/* <MenuItem value="1">Reviewing</MenuItem>
                                            <MenuItem value="2">Customer Confirmation</MenuItem>
                                            <MenuItem value="3">Processing</MenuItem>
                                            <MenuItem value="4">Confirmed</MenuItem>
                                            <MenuItem value="5">Shipped</MenuItem>
                                            <MenuItem value="6">Cancelled</MenuItem> */}
                    </FormInputNoLabel>
                  </div>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangeRep}
                      value={salerep}
                      select
                    >
                      <MenuItem value={0}>Select a Sale Rep</MenuItem>
                      {salerepData != null &&
                        salerepData.map((res) => (
                          <MenuItem
                            value={res.internalid}
                            style={{ color: "#000" }}
                          >
                            {res.entityid}
                          </MenuItem>
                        ))}
                    </FormInputNoLabel>
                  </div>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangeDateFrom}
                      value={dateFrom}
                      type="date"
                      required
                    />
                  </div>
                  <Paragraph bold="bold" color="#707070">
                    to
                  </Paragraph>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 20px" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangeDateTo}
                      value={dateTo}
                      type="date"
                      required
                    />
                  </div>

                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangeCountry}
                      value={country}
                      select
                    >
                      <MenuItem value={0}>Select a Country</MenuItem>
                      <MenuItem value="Malaysia" style={{ color: "#000" }}>
                        Malaysia
                      </MenuItem>
                      <MenuItem value="Singapore" style={{ color: "#000" }}>
                        Singapore
                      </MenuItem>
                    </FormInputNoLabel>
                  </div>

                  {/* <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                                    <FormInputNoLabel
                                        placeholder="Search"
                                        border="1px solid #d7d7d7"
                                        br="6px"
                                        onChange={(e) => console.log(e.target.value)}
                                        value={searchKey}
                                        type="date"
                                    />
                                </div> */}
                  {/* <div className={classes.theWx}>
                                    <div className={classes.theFlex_}>
                                        <FormInputSelect>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={sort}
                                                // defaultValue={sort}
                                                onChange={handleChangeSort}
                                            >
                                                <MenuItem value="0" style={{ color: "#000" }}>
                                                    All Payment Type
                                                </MenuItem>
                                                <MenuItem value="1" style={{ color: "#000" }}>
                                                    Paid
                                                </MenuItem>
                                                <MenuItem value="2" style={{ color: "#000" }}>
                                                    On Hold
                                                </MenuItem>
                                                <MenuItem value="3" style={{ color: "#000" }}>
                                                    Cancelled
                                                </MenuItem>
                                            </Select>
                                        </FormInputSelect>
                                    </div>
                                </div> */}
                </div>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: "#1A5386" }}>
                            <TableRow>
                              <TableCell
                                style={{
                                  borderRadius: "10px 0 0 10px",
                                }}
                                className={classes.theHeadTitle}
                              >
                                Order Number
                              </TableCell>
                              {/* <TableCell className={classes.theHeadTitle}>
                                                                Order Number
                                                            </TableCell> */}
                              <TableCell className={classes.theHeadTitle}>
                                Entity Id
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Status
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Payment
                              </TableCell>
                              {/* <TableCell className={classes.theHeadTitle}>
                                                                Deposit Amount
                                                            </TableCell>
                                                            <TableCell className={classes.theHeadTitle}>
                                                                Outstanding Amount
                                                            </TableCell> */}
                              <TableCell className={classes.theHeadTitle}>
                                Amount
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Sale Rep
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Sale Remarks
                              </TableCell>
                              {/* <TableCell className={classes.theHeadTitle}>
                                                                Payment Type
                                                            </TableCell> */}
                              <TableCell
                                style={{ borderRadius: "0 10px 10px 0" }}
                                className={classes.theHeadTitle}
                              >
                                Created Date
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {receive?.map((item, index) => {
                              return (
                                <TableRow>
                                  <a
                                    style={{ display: "contents" }}
                                    href={`../saledetail/${item.sales_order_id}`}
                                  >
                                    {/* <TableCell>
                                                                                <Checkbox
                                                                                    sx={{
                                                                                        color: "#000",
                                                                                        '&.Mui-checked': {
                                                                                            color: "#000",
                                                                                        },
                                                                                    }} />
                                                                            </TableCell> */}
                                    <TableCell
                                      className={classes.theUnderLineLabel}
                                      style={{
                                        width: "5%",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          "/saledetail/" + item.sales_order_id
                                        )
                                      }
                                    >
                                      {item.sales_order_id != "" &&
                                      item.sales_order_id != null
                                        ? item.sales_order_id
                                        : "-"}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "20%",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          "/saledetail/" + item.sales_order_id
                                        )
                                      }
                                    >
                                      {item.entityid != "" &&
                                      item.entityid != null
                                        ? item.entityid
                                        : "-"}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "10%",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          "/saledetail/" + item.sales_order_id
                                        )
                                      }
                                    >
                                      {item.status}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "15%",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          "/saledetail/" + item.sales_order_id
                                        )
                                      }
                                    >
                                      <div>Currency: {item.currency}</div>
                                      <div>Type: {item.paymenttype}</div>
                                    </TableCell>
                                    {/* <TableCell
                                                onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                            >
                                                {item.deposit_amount}
                                            </TableCell>
                                            <TableCell
                                                onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                            >
                                                {item.outstanding_amount}
                                            </TableCell> */}
                                    <TableCell
                                      style={{
                                        width: "20%",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          "/saledetail/" + item.sales_order_id
                                        )
                                      }
                                    >
                                      <div style={{ color: "#1A5386" }}>
                                        Final Amount: {item.final_amount}
                                      </div>
                                      {item.deposit_amount != "0.00" && (
                                        <React.Fragment>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              color: "#C52626",
                                            }}
                                          >
                                            Deposit Amount:{" "}
                                            {item.deposit_amount}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              color: "#C52626",
                                            }}
                                          >
                                            Outstanding Amount:{" "}
                                            {item.outstanding_amount}
                                          </div>
                                        </React.Fragment>
                                      )}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "10%",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          "/saledetail/" + item.sales_order_id
                                        )
                                      }
                                    >
                                      {item.salesrep_name}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        width: "20%",
                                        // textAlign: "center"
                                      }}
                                      onClick={() =>
                                        navigate(
                                          "/saledetail/" + item.sales_order_id
                                        )
                                      }
                                    >
                                      {item.sales_remark == "" ? (
                                        <>-</>
                                      ) : (
                                        <>{item.sales_remark}</>
                                      )}
                                    </TableCell>
                                    {/* <TableCell
                                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                          >
                                              {item.paymenttype}
                                          </TableCell> */}
                                    <TableCell
                                      style={{
                                        width: "10%",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          "/saledetail/" + item.sales_order_id
                                        )
                                      }
                                    >
                                      {item.created_date}
                                    </TableCell>
                                  </a>
                                </TableRow>
                              );
                            })}
                            {/* {receive != null &&
                                                        receive.map((item, index) => {
                                                            if (searchKey != "") {
                                                                if (
                                                                    item.supplier &&
                                                                    item.name
                                                                        .toUpperCase()
                                                                        .indexOf(searchKey.toUpperCase()) <= -1
                                                                ) {
                                                                    return;
                                                                }
                                                            }
                                                            return (
                                                                <TableRow>
                                                                    <a
                                                                        style={{ display: "contents" }}
                                                                        href={`../pickingorderdetail/${item.receive_id}`}
                                                                    >
                                                                        <TableCell>{item.name}</TableCell>
                                                                        <TableCell>{item.supplier}</TableCell>
                                                                        <TableCell>{item.total_product}</TableCell>
                                                                        <TableCell>{item.total_price}</TableCell>
                                                                        <TableCell>{item.created_date}</TableCell>
                                                                        <TableCell>{item.status}</TableCell>
                                                                    </a>
                                                                    <TableCell>
                                                                        <a
                                                                            style={{
                                                                                color: "#1A5386",
                                                                                textDecoration: "underline",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                            }}
                                                                            onClick={() => handleOpenDetail(item)}
                                                                        >
                                                                            {item.is_report == 1 && (
                                                                                <ReportProblem
                                                                                    sx={{
                                                                                        color: "#F34235",
                                                                                        marginRight: ".4rem",
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            Report List
                                                                        </a>
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })} */}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <div
                        style={{
                          borderTop: "1px solid #707070",
                          borderBottom: "1px solid #707070",
                          margin: "1rem 0 0",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                        <TablePagination
                          // variant="outlined"
                          color="primary"
                          page={pageNum}
                          onPageChange={handleChangePage}
                          count={totalList}
                          // defaultPage={pageList}
                          rowsPerPage={10}
                          rowsPerPageOptions={[10]}
                          // count={10}
                        />
                      </div>
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>
                <br />
                <br />
              </div>
            </Section>
          }
        />
      )}
    </React.Fragment>
  );
}
